import styled, { keyframes } from 'styled-components';

export const StripDiv = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	border: 1px solid var(--borderLightColor);
		border-radius: 91.4939px;
		overflow: hidden;
		padding: .275rem 0.813rem;
		background: var(--defaultBgColor);
`;
export const LabelInfo = styled.div`
		font-size: 0.813rem;
		color: var(--subHeadingColor);
		transition-delay: 1s;
		font-family: Inter;
		font-weight:600;
		position:relative;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		gap: .5rem;
		min-height:27px;
		border-right: none;
		padding-right: .25rem;
		margin-right: 2px;
`;

export const LabelOrientation = styled.label`
	display: flex;
	align-items: center;
	cursor: pointer;
	border: 0px;
	border-left: 0px;
	border-right: 1px solid var(--borderLightColor);
	color: var(--labelValueColor);
	font-size: 0.938rem;
	padding: 0px .65rem;
	background: transparent;
	height: 30px;
	width: auto;
	border-radius: 0px;
	min-width: 40px;
	gap:.438rem;
	paddingLeft: 10px;
	borderLeft: 1px solid var(--borderLightColor);
	borderRight:none;

	&#multiple-panel{
		padding-left: 0.25rem;
	}
	input {
		position: absolute;
		opacity: 0;
		cursor: pointer;
		height: 0;
		width: 0;
	}

`;

export const LabelWithSwitch = styled.div`{
	display: flex;
 gap: .25rem;

	#multiple-points{
		border-left: none;
		border-right: none;
		padding: 0px 5px 0px 8px;

		span{
			color : var(--textTitleColor);
			font-size: .813rem;
			white-space: nowrap;
			font-family: Inter;
			font-weight: 600;
		}
	}
`;
export const ModalToggle = styled.div`{
	display: flex;
	margin-right: 10px;

	.switchButton .button{
	width: 36px;
	height: 20px;
}
		
.checkbox {
	position: relative;
	width: 100%;
	height: 100%;
	padding: 0;
	margin: 0;
	opacity: 0;
	cursor: pointer;
	z-index: 3;

	&:disabled{
		cursor: not-allowed;
	}
}

.knobs {
	z-index: 2;
	background: var(--toggleTrackColor);
	border-radius: 48px;
	border: 1.5px solid var(--toggleTrackColor);
}

.layer {
	width: 100%;
	transition: 0.3s ease all;
	z-index: 1;
}

#button-13 .knobs:before,
#button-13 .knobs:after,
#button-13 .knobs span {
	position: absolute;
	top: 1.5px;
	width:13px;
	height: 12px;
	font-size: 10px;
	font-weight: bold;
	text-align: center;
	line-height: 1;
	border-radius: 2px;
	transition: 0.3s ease all;
}
#button-13 .knobs span {
	top:2px
}

#button-13 .knobs:before,
#button-13 .knobs:after {
	color: var(--disabledTextColor);
	z-index: 1;
}

#button-13 .knobs:before {
	content: "";
	left: 7px;
	visibility: hidden;
	display: none;
	top: 5px;
}
#button-13 .knobs:after{
content: "";
}

#button-13 .knobs span {
	width: 16px;
	height: 16px;
	left: 2px;
	background-color: var(--toggleThumbColor);
	z-index: 2;
	border-radius: 100%;
	top:1px;
}

#button-13 .checkbox:checked + .knobs span {
	left: 16px;
	background-color: var(--toggleThumbColor);
}
#button-13 .checkbox:checked + .knobs:before {
	content: '';
	visibility: visible;
	display: block;
	color: #fff;
}

#button-13 .checkbox:checked + .knobs {
 background-color: var(--primary);
 border: 1.5px solid var(--primary);
}
#button-13 .checkbox:checked + .knobs:after {
	visibility: hidden;
	display: none;
}

#button-13 .checkbox~ .layer {
	background-color: var(--defaultBgColor);
	border-radius:48px ;
}
`;

export const ActionLabel = styled.span`
	color : var(--textTitleColor);
			font-size: .813rem;
			white-space: nowrap;
			font-family: Inter;
			font-weight: 600;
				cursor: pointer;

	&.active{
		color: var(--primary);
	}

`;

const zoomInOut = keyframes`
	0%   { transform: scale(1); }
	50%  { transform: scale(1.10); }
	100% { transform: scale(1); }
`;

export const ActionIcon = styled.svg`
	&.pulse {
  		animation: ${zoomInOut} 3s infinite ease-in-out;
			transition: transform 0.3s ease-in-out;

			&:hover {
				animation-play-state: paused;
			}
			
		}

`;